import { supabase } from '@/shared/lib/supabase/client';
import { AppError } from '@/shared/lib/repository/errors';
import type { ReactionType } from '@/shared/types/tables';
import { emptyReactionCounts, type ReactionSummary } from '../model/types';

/** Article reactions. RLS: public read; insert/update/delete own row only. */
export const reactionsRepository = {
  async getForArticle(articleId: string, userId?: string): Promise<ReactionSummary> {
    const { data, error } = await supabase
      .from('reactions')
      .select('type, user_id')
      .eq('article_id', articleId);
    if (error) throw new AppError(error.message, error.code, error);

    const counts = emptyReactionCounts();
    let mine: ReactionType | null = null;
    for (const row of data ?? []) {
      counts[row.type] += 1;
      if (userId && row.user_id === userId) mine = row.type;
    }
    return { counts, mine };
  },

  async set(articleId: string, userId: string, type: ReactionType): Promise<void> {
    const { error } = await supabase
      .from('reactions')
      .upsert({ article_id: articleId, user_id: userId, type }, { onConflict: 'article_id,user_id' });
    if (error) throw new AppError(error.message, error.code, error);
  },

  async remove(articleId: string, userId: string): Promise<void> {
    const { error } = await supabase
      .from('reactions')
      .delete()
      .eq('article_id', articleId)
      .eq('user_id', userId);
    if (error) throw new AppError(error.message, error.code, error);
  },
};
